import {
  EmpionRecommendation,
  EmpionRecommendationJSON,
  EmpionRecommendationsJSON,
} from '../types/EmpionRecommendationsTypes';

export default class EmpionRecommendationsSerializers {
  static toObject(payload: EmpionRecommendationJSON): EmpionRecommendation {
    return {
      resourceId: payload.resource_id,
      recommendationText: payload.recommendation_text,
      actionItems: payload.action_items.map((action_item) => ({
        resourceId: action_item.resource_id,
        completedAt: action_item.completed_at,
        actionItemText: action_item.action_item_text,
      })),
    };
  }

  static toObjects(payload: EmpionRecommendationsJSON): EmpionRecommendation[] {
    return payload.empion_recommendations.map(EmpionRecommendationsSerializers.toObject);
  }
}
